module.exports = __webpack_public_path__ + "img/sld_metering_panel_em.3741b244.svg";